var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "dashboard-24px",
    width: 22.763,
    height: 22.763,
    viewBox: "0 0 22.763 22.763",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_303",
    fill: "none",
    d: "M0 0h22.763v22.763H0z",
    "data-name": "Path 303"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_304",
    d: "M18.176 4.9v1.9h-3.794V4.9h3.794m-9.485 0v5.691H4.9V4.9h3.791m9.485 7.588v5.691h-3.794v-5.694h3.794m-9.485 3.794v1.9H4.9v-1.9h3.791M20.073 3h-7.588v5.691h7.588zm-9.485 0H3v9.485h7.588zm9.485 7.588h-7.588v9.485h7.588zm-9.485 3.794H3v5.691h7.588z",
    "data-name": "Path 304",
    transform: "translate(-.155 -.155)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.f8702f5f.svg";
export { ForwardRef as ReactComponent };